<app-base-list-page
  [headersList]="headerList"
  (rowClick)="agreementClicked($event)"
  [extraBurgerMenuOptions]="extraBurgerMenuOptions"
  [multiSelectFilterLists]="multiSelectFilterLists"
  [createNew]="agreementClicked"
  newItemLabel="Nyt Anlæg"
  #baseListPage
></app-base-list-page>
